import { useRecoilValue } from 'recoil';
import { DateTime } from 'luxon';
import { CarModel, ExportType } from 'models/StockModel';
import { VoyageStatus } from 'models/VoyageModel';
import { CompanyType } from 'models/CompanyModel';
import auth from 'recoil/atoms/auth';
import voyageFamily from 'recoil/atoms/voyageFamily';


const useVoyagesFilter = () => {
    const my = useRecoilValue(auth);
    const voyages = useRecoilValue(voyageFamily(VoyageStatus.Pending));

    return (car: CarModel) => {
        const port = car.yard?.portId;

        if (!port) return [];

        const lastDate = DateTime.now().startOf('day');

        return voyages
            .filter(v =>
                    (my.type === CompanyType.Master || DateTime.fromISO(v.cutDate) >= lastDate)
                    && (port === v.pol.id || (port === 1 && v.pol.id === 7))
                    && (!car.shipDateLimit || (
                        car.shipDateLimit.after ?
                            (v.eta >= car.shipDateLimit.date) :
                            (v.eta < car.shipDateLimit.date)
                    ))
                    && (car.exportType === ExportType.Car || v.allowDismantled)
            );
    }
};

export default useVoyagesFilter;
